import { ApiService } from '../apiService'
import { TagCategoryDto } from '@features/adventures/types/adventure-editor.types'
import { ApiResponse } from '../types/common'

// Response from /api/Tags/categories - returns object with tagType keys
interface TagCategoriesResponse {
  [tagType: string]: TagCategoryDto[]
}

export const tagsApi = {
  // Get ALL tags in the system (may only return Adventure tags depending on backend)
  getAllTags: () =>
    ApiService.get<TagCategoryDto[]>('/api/tags'),

  // Get ALL tag categories grouped by type (recommended)
  // Returns object with tagType as key and array of categories as value
  // Example: { "1": [...], "2": [...], "3": [...], "4": [...] }
  getAllTagCategories: () =>
    ApiService.get<TagCategoriesResponse>('/api/Tags/categories'),

  // Get tags by specific tag type
  // TagType enum: 1=Interests, 2=GenderIdentity, 3=Adventures, 4=LookingFor, 5=AdventureTypes
  getTagsByType: (tagType: number) =>
    ApiService.get<TagCategoryDto[]>(`/api/Tags/type/${tagType}`),

  // Get tag categories for adventures
  getAdventureTagCategories: () =>
    ApiService.get<TagCategoryDto[]>('/api/tags/categories/Adventures'),

  // Get tag categories for a specific entity type
  getTagCategories: (entityType: string) =>
    ApiService.get<TagCategoryDto[]>(`/api/tags/categories/${entityType}`),
}
